import React, { lazy } from 'react';
export const Bonuses = () => {
  const bonuses = [{
    title: 'Mini Guía: 10 Minutos Para Volver a Ti',
    value: '$29',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1KDUS5Au5C1npPx8eHtCuc/10_minutos_para_volver_a_ti.png',
    description: 'Una rutina diaria corta pero poderosa para reconectar contigo misma después del parto. Incluye ejercicios de respiración, afirmaciones de autoamor y un audio relajante para escuchar antes de dormir o mientras tu bebé descansa.',
    highlight: '✨ Ideal para esos momentos en los que sientes que no puedes más, pero necesitas recargar tu energía sin complicarte.',
    quote: 'No necesitas una hora libre. Solo necesitas diez minutos y la intención de cuidar de ti.'
  }, {
    title: 'Plan de Recuperación del Cuerpo Postparto',
    subtitle: '(Checklist + Tips de expertos)',
    value: '$37',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2rzQQA62KMoai4k5KTYQ61/Plan_de_recuperacion.png',
    description: 'Una guía práctica con los hábitos, alimentos y movimientos que ayudan a tu cuerpo a sanar más rápido. Incluye:',
    items: ['Lista de alimentos que favorecen la cicatrización y equilibrio hormonal', 'Guía de infusiones y snacks saludables para la lactancia', 'Tips para aliviar molestias comunes (inflamación, sudoración, caída del cabello, etc.)', 'Mini rutina de estiramientos suaves aprobados por fisioterapeutas de suelo pélvico'],
    highlight: 'Porque sentirte bien en tu cuerpo también es una forma de sanar tu mente.'
  }, {
    title: 'Diario de Emociones Postparto',
    subtitle: '(Imprimible + editable digitalmente)',
    value: '$19',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ovmaaK97jrKYszfiRriGqz/Diario.png',
    description: 'Un hermoso diario guiado con reflexiones y prompts diarios para expresar cómo te sientes, soltar la culpa y conectar con tu nueva identidad como mamá.',
    items: ['"Hoy me siento…" (con espacio para escribir o colorear)', '"Agradezco por…"', '"Necesito recordarme que…"', '"Mi momento de autocuidado fue…"'],
    highlight: 'Transforma tus emociones en claridad y autocompasión.'
  }];
  return <section className="w-full bg-[#f8f2ee] py-16 px-4" data-id="element-56">
      <div className="max-w-6xl mx-auto" data-id="element-57">
        <h2 className="text-3xl md:text-4xl font-serif font-medium text-center text-[#444] mb-4" data-id="element-58">
          3 BONOS GRATUITOS
        </h2>
        <p className="text-center text-[#8e7f7a] text-xl mb-12" data-id="element-59">
          Incluidos con tu compra hoy
        </p>
        <div className="space-y-12" data-id="element-60">
          {bonuses.map((bonus, index) => <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-61">
              <div className="flex flex-col md:flex-row" data-id="element-62">
                <div className="w-full md:w-1/3 bg-[#faf7f5] p-6 flex items-center justify-center" data-id="element-63">
                  <img src={bonus.image} alt={bonus.title} className="max-w-full h-auto max-h-64 object-contain" loading="lazy" width="300" height="300" data-id="element-64" />
                </div>
                <div className="w-full md:w-2/3 p-6 md:p-8" data-id="element-65">
                  <div className="flex justify-between items-start mb-4" data-id="element-66">
                    <div data-id="element-67">
                      <h3 className="text-2xl font-serif font-medium text-[#444]" data-id="element-68">
                        BONO #{index + 1} — {bonus.title}
                      </h3>
                      {bonus.subtitle && <p className="text-[#8e7f7a]" data-id="element-69">{bonus.subtitle}</p>}
                    </div>
                    <div className="bg-[#f8f2ee] px-3 py-1 rounded" data-id="element-70">
                      <p className="text-[#8e7f7a] font-medium" data-id="element-71">
                        Valor: {bonus.value}
                      </p>
                    </div>
                  </div>
                  <p className="text-[#5a5553] mb-4" data-id="element-72">{bonus.description}</p>
                  {bonus.items && <ul className="list-disc pl-5 mb-4 space-y-1" data-id="element-73">
                      {bonus.items.map((item, idx) => <li key={idx} className="text-[#5a5553]" data-id="element-74">
                          {item}
                        </li>)}
                    </ul>}
                  <p className="text-[#5a5553] font-medium mt-4" data-id="element-75">
                    {bonus.highlight}
                  </p>
                  {bonus.quote && <p className="text-[#8e7f7a] italic mt-4 border-l-2 border-[#d4b7a8] pl-4" data-id="element-76">
                      "{bonus.quote}"
                    </p>}
                </div>
              </div>
            </div>)}
        </div>
        <div className="mt-12 text-center" data-id="element-77">
          <p className="text-xl text-[#444] font-medium mb-4" data-id="element-78">
            💖 Valor total de los bonos: $85
          </p>
          <p className="text-lg text-[#5a5553]" data-id="element-79">
            Pero los recibirás{' '}
            <span className="font-bold text-[#d4b7a8]" data-id="element-80">GRATIS SOLO HOY</span> al
            descargar tu ebook Autocuidado en el Postparto.
          </p>
          <p className="text-lg text-[#5a5553] mt-2" data-id="element-81">
            ✨ Ebook + 3 bonos = Tu kit digital completo de bienestar postparto.
            <br data-id="element-82" />
            Todo descargable e instantáneo — sin esperas, sin envíos.
          </p>
          <p className="text-[#5a5553] font-medium mt-4 mb-6" data-id="element-83">
            ⚠️ Esta oferta especial con los 3 bonos gratuitos es válida
            únicamente hoy. ¡No la dejes escapar!
          </p>
          <div className="max-w-md mx-auto" data-id="element-84">
            <a href="https://mamaplena.com/cart/58296384749649:1" className="block w-full bg-[#c08676] hover:bg-[#b07266] text-white font-medium py-4 px-8 rounded-md transition-all text-xl shadow-md hover:shadow-lg" target="_blank" rel="noopener noreferrer" data-id="element-85">
              OBTÉN TU EBOOK + BONOS AHORA — $9,97
            </a>
            <p className="text-sm text-[#8e7f7a] mt-3" data-id="element-86">
              ✨ Descarga inmediata | Pago 100% seguro
            </p>
          </div>
        </div>
      </div>
    </section>;
};